
window.handleValidatePhone = (elementId) => {
    const blockedKeys = ['e', 'E', '-'];
    
    const element = document.getElementById(elementId);

    element.addEventListener('keydown', handleKeyDown);
    element.addEventListener('paste', handlePaste);

    function handleKeyDown(event) { 
        if (blockedKeys.includes(event.key)) {
            event.preventDefault();
            return false;
        }
        return true;
    };

    function handlePaste(event) {
        const clipboardData = (event.clipboardData || window.clipboardData).getData('text');
        for (let key of blockedKeys) {
            if (clipboardData.includes(key)) {
                event.preventDefault();
                return;
            }
        }
    }
}

